import React from "react";

export default class EmptyTile extends React.PureComponent {
  render() {
    return <div style={{ height: "250px" }} />;
  }
}
